import React from 'react';

import NavigationTabs from 'epn-ui/umd/dist/components/NavigationTabs';

import useI18n from '@i18n';
import { isGlobalDomain } from '@config/globalDomain';

interface ITabsProps {
    toggleTab: (key: string) => void;
    isActive: boolean;
}

export enum TabKeyEnum {
    ACTUAL = 'Actual',
    MARKING = 'Marking',
    ARCHIVE = 'Archive',
}

const { TabPane } = NavigationTabs;

const Tabs: React.FC<ITabsProps> = ({ toggleTab }) => {
    const { t } = useI18n('Creatives');
    const { t: tTools } = useI18n('Tools');

    return (
        <div className="flex border-b-0 text-p1 text-blueGray-300 ">
            <NavigationTabs
                defaultActiveKey="1"
                onChange={(key: TabKeyEnum) => toggleTab(key)}
                tabBarStyle={{ marginBottom: '-1px' }}
                className="w-full"
            >
                <TabPane tab={t(TabKeyEnum.ACTUAL)} key={TabKeyEnum.ACTUAL} />
                {!isGlobalDomain && (
                    <TabPane tab={tTools(TabKeyEnum.MARKING)} key={TabKeyEnum.MARKING} />
                )}
                <TabPane tab={t(TabKeyEnum.ARCHIVE)} key={TabKeyEnum.ARCHIVE} />
            </NavigationTabs>
        </div>
    );
};

export default React.memo(Tabs);
